

































import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { getPhoneCode } from "@/req/login";
import NavBar from "./header.vue";
@Component({
  components: {
    NavBar,
  },
})
export default class Logout extends Vue {
  // 表单效验规则
  public loginFormRules = {
    phone: [{ required: true }, { pattern: /^[\d]{6,11}$/ }],
  };
  public passwordShow = false;
  public btnBgc = false;
  public flag = true;
  public formLogin: any = {
    username: "",
    password: "",
    phone: "",
    code: ""
  };

  public mounted() {
    const data: any = JSON.parse(JSON.stringify(this.$route.params.objData));
    this.formLogin.username = data.username;
    this.formLogin.password = data.password;
  }

  public async onSubmit() {
    const obj = {
      phone: this.formLogin.phone,
    };
    const res = await getPhoneCode(obj);
    if (res.code === 200) {
      this.$router.push({
        name: "code",
        params: { formLogin: this.formLogin},
      });
    } else {
      Toast(res.msg);
    }
  }

  public onChange() {
    this.btnBgc = this.formLogin.phone === "" ? false : true;
  }
}
